import { Alert } from "antd";

const ErrorBanner = ({ errors, onClose }) => {
  if (!errors?.length) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0, // stick to top
        left: 0,
        width: "100%",
        zIndex: 1000,
        padding: "8px 16px",
      }}
    >
      <Alert
        message="Please fix the following errors:"
        description={
          <ul style={{ margin: 0, paddingLeft: 20 }}>
            {errors.map((err, idx) => (
              <li key={idx}>{err}</li>
            ))}
          </ul>
        }
        type="error"
        closable
        onClose={onClose}
        showIcon
      />
    </div>
  );
};

export default ErrorBanner;
